import { render } from "./view95.vue?vue&type=template&id=2718021a&scoped=true&bindings={}"
import script from "./view95.vue?vue&type=script&lang=ts"
export * from "./view95.vue?vue&type=script&lang=ts"

import "./view95.vue?vue&type=style&index=0&id=2718021a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2718021a"

export default script